module.exports = __webpack_public_path__ + "img/horizontal_white.436bdd12.svg";